const REFERRAL_EN = Object.freeze({
  'referral.url.generation.title': 'Generate Partner Referral Link',
  'referral.url.generation.partner': 'Partner',
  'referral.url.generation.partner.customer.id': 'Partner Customer ID',
  'referral.url.generation.partner.select': 'Please select a partner',
  'referral.url.generation.partner.customer.id.input': 'Please enter partner customer ID',
  'referral.url.generation.partner.application-type.input': 'Please select application type',
  'referral.url.generation.url': 'Referral Link:',
  'referral.url.generation.sellerApplicant': 'Qiao Yi Dai',
  'referral.url.generation.expressApplicant': 'Express Application',
});

export { REFERRAL_EN };
